import { Controller } from 'stimulus';
import SmoothScroll from 'smooth-scroll';
import { debounce } from 'lodash';
import { easeOutExpo } from '../../utils/easings';
import {
  scrollPosition,
  scrollOffset
} from '../../utils/scroll';

export default class extends Controller {
  static targets = ['section', 'subnavigation', 'button']

  state = {
    tolerance: 64,
    sections: false,
    currentSection: 0,
    activeClass: 'is-active',
    scrollOffset: false,
    subnavigationOffset: false,
    smoothScroll: new SmoothScroll(),
    fontLoadTimeout: 250,
    width: window.outerWidth,
  }

  initialize() {
    this.onResize = debounce(this.refresh, this.state.tolerance);
  }

  connect() {
    const {
      state
    } = this;
    this.setOffsets();
    this.setSections();
    setTimeout(() => {
      this.refresh();
    }, state.fontLoadTimeout);
  }

  refresh() {
    const {
      state
    } = this;
    const width = window.outerWidth;
    const shouldUpdate = (width !== state.width);
    if (shouldUpdate) {
      this.setOffsets();
      this.setSections();
      state.width = width;
    }
  }

  setOffsets() {
    const {
      state
    } = this;
    const subnavigationOffset = (this.hasSubnavigationTarget) ? this.subnavigationTarget.offsetHeight : 0;
    state.scrollOffset = scrollOffset() + (subnavigationOffset / 2);
    state.subnavigationOffset = subnavigationOffset;
  }

  setSections() {
    const {
      state
    } = this;
    state.sections = Array.from(this.sectionTargets).map((section) => {
      const { index } = section.dataset;
      const bounding = section.getBoundingClientRect();
      return {
        id: index,
        bounds: {
          top: bounding.top + scrollPosition(),
          bottom: bounding.bottom + scrollPosition(),
          offset: state.scrollOffset
        },
      };
    });
  }

  scrollToSection(event) {
    const {
      state
    } = this;
    const { index } = event.currentTarget.dataset;
    const section = this.state.sections[index];
    const targetScrollPosition = (section) ? (section.bounds.top - section.bounds.offset) : 0;
    this.state.smoothScroll.animateScroll(targetScrollPosition, false, {
      speed: 650,
      customEasing: (time) => easeOutExpo(time, 0, 1, 1)
    });
    this.setActiveSection(index);
    this.setSelectedButton(event.currentTarget);
  }

  setActiveSection(section) {
    const {
      state
    } = this;
    state.currentSection = parseInt(section, 10);
  }

  setSelectedButton(button) {
    const {
      state
    } = this;
    this.buttonTargets.forEach((node) => node.classList.remove(state.activeClass));
    button.classList.add(state.activeClass);
  }
}
